import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  warningModalTitle: {
    id: '1k5TlI',
    description:
      'Title of the dismissable warning modal shown when the packer dismisses a packing recommendation under the Warning enforcement mode',
    defaultMessage: 'Shipping Without the Recommended Package?',
  },
  warningModalBody: {
    id: '2cynNW',
    description:
      'Body text of the dismissable warning modal shown when a packing recommendation is dismissed under the Warning enforcement mode',
    defaultMessage: 'You can still ship without applying this recommendation, but it will be noted on the order.',
  },
  warningModalProceed: {
    id: 'VA5+CH',
    description: 'Button that acknowledges the warning and continues without applying the packing recommendation',
    defaultMessage: 'Ship Anyway',
  },
  warningModalCancel: {
    id: 'fvfVqW',
    description: 'Button that cancels dismissing the packing recommendation so the packer can go back and apply it',
    defaultMessage: 'Cancel',
  },
  overrideReasonModalHeader: {
    id: '/RAAND',
    description:
      'Header for the modal that requires a typed reason before shipping without the recommended package, under the Enforced enforcement mode',
    defaultMessage: 'Reason Required',
  },
  overrideReasonModalDescription: {
    id: '6HI8Bd',
    description: 'Description text for the packing recommendation override reason modal',
    defaultMessage: 'A reason is required before shipping without the recommended package.',
  },
  overrideReasonLabel: {
    id: 'XKdDwp',
    description: 'Label for the reason input in the packing recommendation override reason modal',
    defaultMessage: 'Why are you not using the recommended package?',
  },
  overrideReasonRequiredError: {
    id: 'GsCG+g',
    description: 'Error message when the override reason is not provided',
    defaultMessage: 'Reason is required.',
  },
  overrideReasonCancel: {
    id: 'fvfVqW',
    description: 'Button that cancels dismissing the packing recommendation so the packer can go back and apply it',
    defaultMessage: 'Cancel',
  },
  overrideReasonSubmit: {
    id: 'FvxEk+',
    description: 'Submit button text for the packing recommendation override reason modal',
    defaultMessage: 'Confirm',
  },
});
